// extracted by mini-css-extract-plugin
export default {"separator":"WNQ0t4UDmEzlDCe7u_lo","card":"YIz1SoEE1Ot1ClwhFVQQ","cardInfo":"agted5M4gFRPZmNVxAZw"};